import React from 'react';
import { socialsPropTypes } from './SocialsPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Socials.module.scss';
const Socials = ({
  socials
}) => {
  if (!socials) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, Object.keys(socials).map((key, index) => socials[key] && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer nofollow",
    key: index,
    href: socials[key],
    className: styles.rootLink
  }, /*#__PURE__*/React.createElement(Icon, {
    name: key,
    size: {
      width: 24,
      height: 24
    }
  }))));
};
export default Socials;